import React from "react";
import RouteListComponent from "../components/RouteListComponent";

const RouteList = () => {
  return <RouteListComponent />;
};

export default RouteList;
